import { Box } from "@mui/material";
import { Field } from "components/DataTable/renderComponents";
import { useState } from "react";
import { useSelector } from "react-redux";
import SalesChannelModal from "./SalesChannelModal";

const SalesChannel = ({ siteDetails, unitId = undefined }) => {
  const [open, setOpen] = useState(false);
  const profile = useSelector((state) => state.profile);

  if (!profile?.is_staff) return;

  return (
    <Box>
      <Field
        label="Sales Channel"
        value={
          <Box sx={{ textTransform: "capitalize" }}>
            {siteDetails?.sales?.channel}
          </Box>
        }
        onEdit={() => setOpen(true)}
      />

      {open && (
        <SalesChannelModal
          open={open}
          onClose={() => setOpen(false)}
          siteDetails={siteDetails}
          unitId={unitId}
        />
      )}
    </Box>
  );
};

export default SalesChannel;
